import { COUPON_COMP_INCLUSIVE_LOCALES } from './src-constants-locale.js';

const isLocaleEnabled = (l) => {
  const locale = toLocale(l);
  return COUPON_COMP_INCLUSIVE_LOCALES.includes(locale);
};
const toLocale = (l) => {
  try {
    const parts = l.split("-");
    return `${parts[0].toLowerCase()}-${parts[1].toUpperCase()}`;
  } catch (e) {
    return "xx-YY";
  }
};
const getMarketFromLocale = (locale) => {
  try {
    const parts = locale.split("-");
    return `${parts[1].toUpperCase()}`;
  } catch (e) {
    return void 0;
  }
};

export { getMarketFromLocale, isLocaleEnabled, toLocale };
//# sourceMappingURL=src-utils-locale.util.js.map
